import { render, staticRenderFns } from "./settleCard.vue?vue&type=template&id=468c85b8&scoped=true"
import script from "./settleCard.vue?vue&type=script&lang=js"
export * from "./settleCard.vue?vue&type=script&lang=js"
import style0 from "./settleCard.vue?vue&type=style&index=0&id=468c85b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c85b8",
  null
  
)

export default component.exports